import SubscriptionPriceSection from '../components/SubscriptionPriceSection';
import PriceGroupsSection from '../components/PriceGroupsSection/PriceGroupsSection';
import SaleValiditySection from '../components/SaleValiditySection';
import ValidityAndTimesSection from '../components/ValidityAndTimesSection';
import RedemptionValiditySection from '../components/RedemptionValiditySection';
import * as css from './PricingStep.css';

function PricingStep() {
    return (
        <css.container>

            <SubscriptionPriceSection />

            <PriceGroupsSection />

            <SaleValiditySection />

            <RedemptionValiditySection />

            <ValidityAndTimesSection />
        </css.container>
    );
}

export default PricingStep;

